import { makeStyles } from 'tss-react/mui';
import { Box, Container, Typography } from '@mui/material';
import Link from 'components/Link';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const useStyles = makeStyles()((theme) => ({
  footerWrapper: {
    width: '100%',
    backgroundColor: '#2c367e',
    marginTop: 'auto',
    flexShrink: 0,
  },
  footer: {
    color: 'white',
    backgroundColor: 'transparent',
    border: 'none',
    height: '26em',
    textAlign: 'center',
    paddingTop: '3em',
    '&&': {
      color: 'white',
    },
  },
  footerTitle: {
    '&&': {
      color: 'white',
      fontWeight: 700,
      fontSize: '2.5em',
      marginTop: '1em',
    },
  },
  footerSubTitle: {
    '&&': {
      color: 'white',
      fontWeight: 100,
      fontSize: '1.2em',
    },
  },
  socialNetworks: {
    '& img': {
      width: '38px',
      height: '38px',
    },
  },
  icons: {
    color: 'white',
    margin: '0.6em 0.2em',
  },
  links: {
    fontWeight: '600',
    '& a': {
      color: 'white',
    },
  },
  logo: {},
}));

const Footer = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.footerWrapper}>
      <Container className={classes.footer}>
        <Typography variant="h5" className={classes.footerTitle}>
          RESTONS CONNECTÉS!
        </Typography>
        <Typography variant="h6" className={classes.footerSubTitle}>
          Suivez nos aventures sur les réseaux sociaux :
        </Typography>
        <div className={classes.socialNetworks}>
          <a href="https://www.facebook.com/OuaaaTransition" target="_blank" rel="noreferrer">
            <FacebookIcon className={classes.icons} fontSize="large" />
          </a>
          <a href="https://www.instagram.com/ouaaa_transition/" target="_blank" rel="noreferrer">
            <InstagramIcon className={classes.icons} fontSize="large" />
          </a>
        </div>
        <div className={classes.links}>
          <Link href="/about">Qui sommes-nous ?</Link>
          <span> - </span>
          <Link href="/legalmention">Mentions Légales</Link>
          <span> - </span>
          <Link href="/faq">FAQ</Link>
          <span> - </span>
          <Link href="/contact">Contact</Link>
          <span> - </span>
          <Link href="/charter">Charte</Link>
          <span> - </span>
          <Link href="/odd">ODD</Link>
          <span> - </span>
          <Link href="/annuaire">Annuaire</Link>
        </div>
        <div className={classes.logo} />
      </Container>
    </Box>
  );
};

export default Footer;
